/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import { FormControl, FormLabel, IconButton } from "@mui/material";
import TextInput from "../../components/common/textInput/TextInput";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import ButtonView from "../../components/common/button/ButtonView";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import {
  ICON_STYLE,
  MARGIN_R_10,
  VEHICLE_KEYS,
} from "../../utils/GlobalConstants";
import { VEHICLE_CREATION_FORM_VALUES } from "../../utils/GlobalFormConstants";
import { MAKE_MODEL_ERR, YEAR_ERR } from "../../utils/GlobalMessageConstants";
import DialogView from "../common/dialog/DialogView";
import VinDialogView from "../survey/VinDialogView";
import {
  addItemInSelectedVehicle,
  addItemVin,
  deleteItemsFromSelectedVehicle,
} from "../../store/SurveyPageData";
import { addItemInVehicleListUpdate } from "../../store/SurveyPageData";
import { useTranslation } from "react-i18next";
import "./styles/VehicleForm.css";
import Loader from "../../components/common/dialog/Loader";
import { addItemInPartListUpdate } from "../../store/SurveyPageData";
import {
  addDuplicateVehicle,
  decodeVinNumber,
  getSingleVehicleDetails,
  vinValidation,
} from "../../services/SurveyRequest";
import { constructDCStore } from "../../utils/genericUse/CommonUse";
import AlertView from "../../components/common/dialog/AlertView";
const VehicleForm = () => {
  const [open, setOpen] = useState(false);
  const [addNewClicked, setAddNewClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errMsg, setMsg] = useState("");
  const [errMake, setErrMake] = useState(false);
  const [errModel, setErrModel] = useState(false);
  const [errMsgVIN, setErrMsgVIN] = useState("");
  const [errMsgYear, setErrMsgYear] = useState("");
  const [localData, setLocalData] = useState(VEHICLE_KEYS);
  const [successMsg, setSuccessMsg] = useState("");
  const [alertView, setAlertView] = useState(false);
  const [vinStatus, setVinStatus] = useState()
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const selectedVehicle = useSelector(
    (state) => state?.SurveyPageData?.selectedVehicle
  );
  const selectedSurvey = useSelector(
    (state) => state?.SurveyPageData?.selectedSurvey
  );

  useEffect(() => {
    if (selectedVehicle?.id) {
      setLocalData(selectedVehicle);
      setAddNewClicked(true);
      setErrMake(false);
      setErrModel(false);
      setMsg("");
      setErrMsgVIN("");
    } else {
      setLocalData(VEHICLE_KEYS);
      setAddNewClicked(true);
      setErrMake(false);
      setErrModel(false);
      setMsg("");
      setSuccessMsg("");
      setErrMsgVIN("");
    }
  }, [selectedVehicle]);

  useEffect(() => {
    if (selectedSurvey?.id) {
      setLocalData(VEHICLE_KEYS);
      setAddNewClicked(false);
      setMsg("");
      setErrMake(false);
      setErrModel(false);
      setSuccessMsg("");
    }
  }, [selectedSurvey]);

  const handleClose = () => {
    dispatch(addItemVin({}));
    setOpen(false);
  };

  const handleVehicleFormChange = (e) => {
    if (e.target.name === "make") {
      if (e.target.value !== "") {
        setErrMake(false);
        setMsg("");
      }
    }
    if (e.target.name === "model") {
      if (e.target.value !== "") {
        setErrModel(false);
        setMsg("");
      }
    }

    if (e.target.name === "vin") {
      

function isValidInput(value) {
  const regex = /^[A-Za-z0-9]{9,17}$/;
  return regex.test(value);
}


      if (!isValidInput(e.target.value)) {
        setErrMsgVIN(t("tab1.messages.vin_len"));
      } else {
        setErrMsgVIN("");
      }
    }
    if (e.target.name === "year") {
      if (e.target.value < 1970) {
        setErrMsgYear(YEAR_ERR);
      } else {
        setErrMsgYear("");
      }
    }
    if (e.target.name === "unitNo") {
      setLocalData({
        ...localData,
        [e.target.name]: constructDCStore(e.target.value),
      });
    }
    if (e.target.name !== "unitNo") {
      const vinValidation = e.target.name === 'vin' ? undefined : localData?.vinValidation
      setLocalData({ ...localData, [e.target.name]: e.target.value, vinValidation });
    }
  };

  const handleClickOpen = async () => {
    if (localData?.vin) {
      setOpen(true);
      try {
        const payload = { vin: localData?.vin };
        const getVinData = await decodeVinNumber(payload);
        dispatch(addItemVin(getVinData.data));
      } catch (e) {
        dispatch(addItemVin(e.getVinData.data));
        console.log(e);
      }
    }
  };

  const addDuplicateRecord = async (payload, role, aid) => {
    try {
      const saveDuplicateData = await addDuplicateVehicle(payload);
      const getVehicleData = await getSingleVehicleDetails(
        saveDuplicateData?.data?.ids[0]
      );
      dispatch(addItemInSelectedVehicle(getVehicleData?.vehicle));
      dispatch(
        addItemInVehicleListUpdate([...saveDuplicateData?.data?.ids[0]])
      );
      setIsLoading(false);
      setSuccessMsg(t("tab1.messages.vehicle_save"));
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };

  const updateRecord = async (payload) => {
    try {
      const saveDuplicateData = await addDuplicateVehicle(payload);
      dispatch(addItemInVehicleListUpdate([...saveDuplicateData?.data?.id]));
      dispatch(addItemInSelectedVehicle({ ...localData }));
      setIsLoading(false);
      setSuccessMsg(t("tab1.messages.vehicle_update"));
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };

  const constructPayLoad = () => {
    let tempPayload = {
      surveyId: selectedSurvey?.id,
      vehicles: [
        {
          vin: localData.vin,
          make: localData.make,
          model: localData.model,
          makeModel: localData.makeModel,
          engine: localData.engine,
          subModel: localData.subModel,
          unitNo: localData.unitNo,
          sortBy: localData.sortBy,
          year: localData.year,
          comments: localData.comments,
        },
      ],
    };
    return tempPayload;
  };

  const onDuplicateClick = () => {
    setIsLoading(true);
    let payload;
    if (selectedVehicle?.id) {
      let aid = selectedVehicle?.id;
      payload = constructPayLoad();
      payload.metaData = {
        isDuplicate: true,
        duplicateId: aid,
      };
      addDuplicateRecord(payload, "duplicate", aid);
    }
  };

  const onAddNewVehicleClick = () => {
    setAddNewClicked(true);
    setMsg("");
    setErrMake(false);
    setErrModel(false);
    setErrMsgVIN("");
    setErrMsgYear("");
    setSuccessMsg("");
    setLocalData(VEHICLE_KEYS);
    dispatch(deleteItemsFromSelectedVehicle());
    dispatch(addItemInPartListUpdate({}));
  };

  const validateInputData = () => {
    if (localData?.make?.trim() === "" || localData?.model?.trim() !== "") {
      setMsg(MAKE_MODEL_ERR);
      setErrMake(true);
    }
    if (localData?.make?.trim() !== "" || localData?.model?.trim() === "") {
      setMsg(MAKE_MODEL_ERR);
      setErrModel(true);
    }
  };
  const getVinData = async (vin) => {
    let vinValidationMssg = ''
    let flag = 0
    //const response = vinValidation({vin:row.source?.vin})
    if (vin !== '') {
      const response = await vinValidation({ vin: vin })
      if (response?.data?.vinItems?.error?.errorCode === '404' && !response?.data?.vinItems?.decodedVIN) {
        vinValidationMssg = 'Invalid Vin'
        flag = 0;
      } else if (response?.data?.vinItems?.decodedVIN) {
        vinValidationMssg = ''
        flag = 1;
      } else {
        vinValidationMssg = response?.data?.vinItems?.error?.message || 'Invalid Vin'
        flag = 0;
      }
    } else {
      // vinValidationMssg = 'No Vin Found'
      // flag=1;
      vinValidationMssg = ''
      flag = 1;
    }
    return ({ flag, vinValidationMssg })
  }
  const onSaveClick = async () => {
    if (localData?.vin && localData?.vin != "") {
      const vinValidation = await getVinData(localData?.vin)
      if (vinValidation?.flag === 0) {
        setAlertView(vinValidation?.flag === 0 ? true : false)
        setVinStatus([{ vin: localData?.vin, message: vinValidation?.vinValidationMssg }])
      } else { saveLocalData() }

    } else {
      saveLocalData()
    }

  };
  const saveLocalData = () => {
    let payload
    const isEmpty = Object.values(localData).every(
      (x) => x === null || x === ""
    );
    if (selectedVehicle?.id) {
      if (!isEmpty) {
        validateInputData();
        if (localData?.make?.trim() !== "" && localData?.model?.trim() !== "") {
          setIsLoading(true);
          setMsg("");
          setErrMake(false);
          setErrModel(false);
          payload = constructPayLoad();
          payload.updateType = 0;
          payload.vehicles[0].id = selectedVehicle.id;
          updateRecord(payload);
        }
      }
    } else {
      if (!isEmpty) {
        validateInputData();
        if (localData?.make?.trim() !== "" && localData?.model?.trim() !== "") {
          setIsLoading(true);
          setMsg("");
          setErrMake(false);
          setErrModel(false);
          payload = constructPayLoad();
          payload.updateType = 0;
          addDuplicateRecord(payload, "add");
          setMsg("");
          setErrMsgVIN("");
          setErrMsgYear("");
        }
      } else {
        setErrMake(true);
        setErrModel(true);
        setMsg(MAKE_MODEL_ERR);
      }
    }
    setVinStatus(); setAlertView(false)
  }
  const AddVehicleFromVin = (addVehicleObj) => {
    if (open) {
      setOpen(false);
    }
    let payload = {
      surveyId: selectedSurvey?.id,
      surveyType: 0,
      vehicles: [addVehicleObj],
    };
    addDuplicateRecord(payload, "add");
  };

  return (
    <React.Fragment>
      <AlertView
        isOpen={alertView}
        handleCloseAlertView={() => { setVinStatus(); setAlertView(false) }}
        handleImport={saveLocalData}
        vinStatus={vinStatus}
        valid={'vin'}
        isSurvery={true}
      />
      <DialogView
        testid="vinpopup"
        open={open}
        width={"35%"}
        maxWidth={"35em!important"}
        heading={localData ? localData.vin : "Maintenance"}
        handleClose={() => handleClose()}
        childComponet={
          <VinDialogView
            selectedSurvey={selectedSurvey}
            onAdd={(addVehicleObj) => AddVehicleFromVin(addVehicleObj)}
            handleClose={() => handleClose()}
          />
        }
      />
      {/* Error Message */}
      {errMsg !== "" && (
        <React.Fragment>
          <div className="errMsg">{errMsg}</div>
        </React.Fragment>
      )}
      {/* Vehicle Form Input Fields */}
      <FormControl fullWidth>
        {VEHICLE_CREATION_FORM_VALUES.map((data, index) => {
             const errorForKey =
                    data.key === "make" ? errMake :
                    data.key === "model" ? errModel :
                    data.key === "year" ? !!errMsgYear :
                    data.key === "vin" ? (localData?.vinValidation || errMsgVIN !== "") :
                    false;
          return (
            <React.Fragment key={index}>
              {data.key !== "vin" &&
                data.key !== "year" &&
                data.key !== "sortBy" &&
                data.key !== "unitNo" && (
                  <React.Fragment>
                   <>
                   <FormLabel
                                  htmlFor={data.key}
                                  sx={{
                                    color: errorForKey ? "error.main" : "text.primary",
                                    "& .required-asterisk": {
                                      color: errorForKey ? "error.main" : "inherit",
                                    },
                                  }}
                                >
                                  {t(`tab1.contents.${data.label}`)}
                                  {data.required && <span className={"required-asterisk"}> <i>(Required *)</i></span>}
                                </FormLabel>
                    <TextInput
                      label={t(`tab1.contents.${data.label}`)}
                      name={data.key}
                      required={data.required}
                      disabled={addNewClicked ? false : true}
                      value={
                        localData && localData[data.key]
                          ? localData[data.key]
                          : ""
                      }
                      testid="input"
                      onChange={handleVehicleFormChange}
                      InputLabelProps={
                        data.InputLabelProps && {
                          shrink:
                            localData && localData[data.key]
                              ? localData[data.key]
                              : "",
                        }
                      }
                      error={
                        data.key === "make"
                          ? errMake
                          : data.key === "model"
                            ? errModel
                            : false
                      }
                      inputProps={{ "data-testid": data.testid }}
                    /></> 
                  </React.Fragment>
                )}

              {(data.key === "year" ||
                data.key === "sortBy" ||
                data.key === "unitNo") && (
                  <React.Fragment>
                    <FormLabel
                                    htmlFor={data.key}
                                    sx={{
                                      color: errorForKey ? "error.main" : "text.primary",
                                      "& .required-asterisk": {
                                        color: errorForKey ? "error.main" : "inherit",
                                      },
                                    }}
                                  >
                                    {t(`tab1.contents.${data.label}`)}
                                    {data.required && <span className={"required-asterisk"}> <i>(Required *)</i></span>}
                                  </FormLabel>
                    <TextInput
                      label={t(`tab1.contents.${data.label}`)}
                      name={data.key}
                      required={data.required}
                      disabled={addNewClicked ? false : true}
                      onChange={handleVehicleFormChange}
                      value={
                        localData &&
                          (localData[data.key] == "" ||
                            localData[data.key] == undefined)
                          ? ""
                          : localData && localData[data.key]
                      }
                      InputLabelProps={
                        data.InputLabelProps && {
                          shrink:
                            localData &&
                              (localData[data.key] == "" ||
                                localData[data.key] == undefined)
                              ? ""
                              : localData && localData[data.key],
                        }
                      }
                      inputProps={{ "data-testid": data.testid }}
                      error={data.key === "year" ? errMsgYear : false}
                    />
                    {errMsgYear !== "" && data.key === "year" && (
                      <React.Fragment>
                        <div className="errMsg">{errMsgYear}</div>
                      </React.Fragment>
                    )}
                  </React.Fragment>
                )}
              {data.key === "vin" && (
                <React.Fragment>
<FormLabel
                htmlFor={data.key}
                sx={{
                  color: errorForKey ? "error.main" : "text.primary",
                  "& .required-asterisk": {
                    color: errorForKey ? "error.main" : "inherit",
                  },
                }}
              >
                {t(`tab1.contents.${data.label}`)}
                {data.required && <span className={"required-asterisk"}> <i>(Required *)</i></span>}
              </FormLabel>
                  <TextField
                    size="small"
                    testid="vin"
                    error={localData?.vinValidation || errMsgVIN !== "" ? true : false}
                    helperText={errMsgVIN !== "" ? errMsgVIN : localData?.vinValidation}
                    className="input-style"
                    label={t(`tab1.contents.${data.label}`)}
                    disabled={addNewClicked ? false : true}
                    value={localData?.vin}
                    name={data.key}
                    onChange={handleVehicleFormChange}
                    InputLabelProps={{ shrink: localData?.vin, className: "visually-hidden" }}
                    InputProps={{
                      "data-testid": "vin-onchange-test",
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            testid="icon"
                            aria-label="toggle password visibility"
                            onClick={() => handleClickOpen()}
                            edge="end"
                            disabled={localData?.vin?.trim().length > 0 ? false : true}
                          >
                            <SearchIcon style={ICON_STYLE} />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </React.Fragment>
              )}
            </React.Fragment>
          );
        })}
        {successMsg !== "" && (
          <React.Fragment>
            <div className="successMsg">{successMsg}</div>
          </React.Fragment>
        )}
        <div className="vehicleButtonSection">
          <ButtonView
            label={t("tab1.contents.Add_New_Vehicle")}
            style={MARGIN_R_10}
            testid="add-onchange-test"
            onClick={onAddNewVehicleClick}
            disabled={selectedSurvey?.id ? false : true}
          />
          <ButtonView
            testid="save"
            label={t("tab1.contents.Save")}
            style={MARGIN_R_10}
            onClick={onSaveClick}
            disabled={selectedSurvey?.id ? false : true}
          />
          <ButtonView
            testid="duplicate"
            label={t("tab1.contents.Duplicate")}
            onClick={onDuplicateClick}
            disabled={selectedVehicle?.id ? false : true}
          />
        </div>
      </FormControl>
      {isLoading && <Loader className="Loader-style" />}

    </React.Fragment>
  );
};

export default VehicleForm;